var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel"},[_c('div',{staticClass:"title qb-container"},[_c('h2',[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"panel-content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }